import { ChangeEvent } from 'react';
import InputTextLine from '../../../../juristec-ui/core/InputTextLine';
import TextArea from '../../../../juristec-ui/core/TextArea';
import { verifyInput } from '../../../../juristec-ui/utils/validators/inputTextValidators';
import { trimString } from '../../../../juristec-ui/utils/functions/formatString';
import { MainContainer } from './styled';

export interface textState {
  value: string;
  error: boolean;
  errorMsg: string;
}

interface GroupInfoProps {
  nameState: [textState, (state: textState) => void];
  descriptionState: [textState, (state: textState) => void];
  markDirty: () => void;
}

const GroupInfo = ({
  nameState,
  descriptionState,
  markDirty,
}: GroupInfoProps) => {
  const [name, setName] = nameState;
  const [description, setDescription] = descriptionState;

  const handleName = (val: string) => {
    const errMsg = verifyInput(val, true, 3, 50);
    setName({
      value: val,
      error: errMsg.length !== 0,
      errorMsg: errMsg,
    });
  };

  const handleNameEvent = (e: ChangeEvent<HTMLInputElement>) => {
    markDirty();
    handleName(e.target.value);
  };

  const nameTrim = () => {
    handleName(trimString(name.value));
  };

  const handleDescription = (val: string) => {
    const errMsg = verifyInput(val, false, 3);
    setDescription({
      value: val,
      error: errMsg.length !== 0,
      errorMsg: errMsg,
    });
  };

  const handleDescriptionEvent = (e: ChangeEvent<HTMLInputElement>) => {
    handleDescription(e.target.value);
    markDirty();
  };

  const descriptionTrim = () => {
    handleDescription(description.value.trim());
  };

  return (
    <MainContainer>
      <InputTextLine
        label="Nome do Grupo"
        value={name.value}
        setValue={handleName}
        onChange={handleNameEvent}
        onBlur={nameTrim}
        error={name.errorMsg.length > 0}
        errorMessage={name.errorMsg}
      />
      <TextArea
        // @ts-expect-error not typed yet
        label="Descrição"
        onChange={handleDescriptionEvent}
        onBlur={descriptionTrim}
        value={description.value}
        error={description.errorMsg.length > 0}
        errorMessage={description.errorMsg}
        styleContainer={{ marginTop: '10px', height: '35vh' }}
      />
    </MainContainer>
  );
};

export default GroupInfo;
